// noinspection DuplicatedCode

import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  BsFileEarmarkExcelFill,
  BsFilePdfFill,
  BsUpload,
  BsDownload,
  BsPlusLg,
  BsArrowLeft,
} from "react-icons/bs";

import Card from "@material-tailwind/react/Card";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import Skeltons from "../../../components/loading/Skeltons";
import { alertService } from "../../../services/AlertService";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
  getMpayrollHO,
  insertMpayrollHO,
  updateMpayrollHO,
  mpayrollSelectorHO,
} from "./MPayrollSlice";
import {
  getMinTipeKaryawan,
  tipeKaryawanSelector,
} from "../tipe-karyawan/tipeKaryawanSlice";
import {
  exportPayrollHOExcel,
  downloadPayrollHOTemplate,
  parsePayrollHOFile,
} from "./mpayrollhoExcel";

import { Colors } from "../../../assets/Colors";

const PAGE_SIZE = 10;
const rp = (v) =>
  (Number(v) || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 });

const MPayrollPageHO = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [firstLoading, setFirstLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [tipeFilter, setTipeFilter] = useState("");
  const [pageC, setPageC] = useState(1);

  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const [exporting, setExporting] = useState(false);
  const [importing, setImporting] = useState(false);
  const fileInputRef = useRef(null);

  const mpayrol = useSelector(mpayrollSelectorHO);
  const tipeKaryawan = useSelector(tipeKaryawanSelector);

  const API = process.env.REACT_APP_API_URL;
  const authHeader = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return { Authorization: "Bearer " + user?.Token, Accept: "*/*" };
  };

  const loadAll = useCallback(() => {
    dispatch(
      getMpayrollHO({ start: 0, count: 999999, search: "", tipekaryawan: "" })
    );
  }, [dispatch]);

  useEffect(() => {
    loadAll();
    dispatch(getMinTipeKaryawan({ search: "" }));
  }, []);

  useEffect(() => {
    if (mpayrol.isGetSuccess && !firstLoading) setFirstLoading(true);
  }, [mpayrol.isGetSuccess, firstLoading]);

  // ── Data list (client-side filter + pagination) ──────────────
  const rows = useMemo(
    () => (Array.isArray(mpayrol.data) ? mpayrol.data : []),
    [mpayrol.data]
  );

  const filtered = useMemo(() => {
    let r = [...rows];
    if (tipeFilter) r = r.filter((x) => (x.TipeKaryawan || "") === tipeFilter);
    const kw = searchQuery.trim().toLowerCase();
    if (kw) {
      r = r.filter((x) =>
        [x.ID, x.Nik, x.NamaKaryawan, x.NamaJabatan, x.NamaBagian, x.TipeKaryawan]
          .some((v) => v && v.toString().toLowerCase().includes(kw))
      );
    }
    return r;
  }, [rows, searchQuery, tipeFilter]);

  const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const safePage = Math.min(pageC, totalPage);
  const pageRows = useMemo(() => {
    const s = (safePage - 1) * PAGE_SIZE;
    return filtered.slice(s, s + PAGE_SIZE);
  }, [filtered, safePage]);

  useEffect(() => {
    setPageC(1);
  }, [searchQuery, tipeFilter, mpayrol.data]);

  // ── Add / Edit (HO: tanpa Shift/BPJS) ────────────────────────
  // .unwrap() supaya request yang GAGAL di backend (mis. field angka diisi
  // teks) benar-benar melempar error di sini, bukan tetap dianggap sukses.
  function handleInsertPayroll(param) {
    dispatch(
      insertMpayrollHO({
        Nik: param.dropdownKaryawanValue,
        UpahPokok: param.inputOneValue,
        Keahlian: param.inputTwoValue,
        JkIN: param.inputThreeValue,
        JkOUT: param.inputFourValue,
        THarian: param.inputFiveValue,
        TLemburMakan: param.inputSixValue,
        Harikeenam: param.dropDownDayValue,
      })
    )
      .unwrap()
      .then(() => {
        alertService.success("Berhasil menambah data", { autoClose: true });
        loadAll();
      })
      .catch((err) => {
        toast.error(
          "Gagal menambah data: " +
            (err?.message ||
              "Periksa kembali isian (Upah Pokok/Keahlian/Tunjangan harus berupa angka)")
        );
      });
  }

  function handleUpdatePayroll(param) {
    dispatch(
      updateMpayrollHO({
        Nik: param.dropdownKaryawanValue,
        UpahPokok: param.inputOneValue,
        Keahlian: param.inputTwoValue,
        JkIN: param.inputThreeValue,
        JkOUT: param.inputFourValue,
        THarian: param.inputFiveValue,
        TLemburMakan: param.inputSixValue,
        Harikeenam: param.dropDownDayValue,
      })
    )
      .unwrap()
      .then(() => {
        alertService.success("Berhasil mengubah data", { autoClose: true });
        loadAll();
      })
      .catch((err) => {
        toast.error(
          "Gagal mengubah data: " +
            (err?.message ||
              "Periksa kembali isian (Upah Pokok/Keahlian/Tunjangan harus berupa angka)")
        );
      });
  }

  function handleModal(status) {
    setShowModalAdd(status.showModalAdd);
    setShowModalEdit(status.showModalEdit);
  }

  function openAdd() {
    setCurrentData({});
    handleModal({ showModalAdd: true, showModalEdit: false });
  }
  function openEdit(row) {
    setCurrentData(row);
    handleModal({ showModalAdd: false, showModalEdit: true });
  }

  // ── Export Excel / PDF ───────────────────────────────────────
  async function handleExportExcel() {
    if (exporting) return;
    try {
      setExporting(true);
      if (!filtered.length) {
        toast.warn("Tidak ada data untuk diexport");
        return;
      }
      exportPayrollHOExcel(filtered);
      toast.success(`Berhasil export ${filtered.length} data`);
    } catch (e) {
      toast.error("Gagal export: " + (e.message || "unknown error"));
    } finally {
      setExporting(false);
    }
  }

  function handleExportPDF() {
    if (!filtered.length) {
      toast.warn("Tidak ada data untuk diexport");
      return;
    }
    const head = [
      ["ID", "Nik", "Nama Karyawan", "Bagian", "Jabatan", "Upah Pokok", "Keahlian", "Jam IN", "Jam OUT"],
    ];
    const body = filtered.map((r) => [
      r.ID || "",
      r.Nik || "",
      r.NamaKaryawan || "",
      r.NamaBagian || "",
      r.NamaJabatan || "",
      rp(r.UpahPokok),
      rp(r.Keahlian),
      r.JkIN || "",
      r.JkOUT || "",
    ]);
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(12);
    doc.text("Master Payroll HO", 14, 14);
    autoTable(doc, {
      head,
      body,
      startY: 20,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [47, 85, 151], textColor: 255, fontStyle: "bold" },
    });
    doc.save("Master_Payroll_HO.pdf");
  }

  // ── Import Excel (upsert via endpoint HO) ────────────────────
  async function fetchAllPayroll() {
    const fd = new FormData();
    fd.append("start", 0);
    fd.append("count", 999999);
    fd.append("search", "");
    fd.append("tipekaryawan", "");
    const res = await axios.post(API + "getMasterPayrollHO", fd, {
      headers: authHeader(),
    });
    return res.data?.data || [];
  }

  async function handleImportFile(e) {
    const file = e.target.files?.[0];
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (!file) return;
    const name = file.name.toLowerCase();
    if (!name.endsWith(".xlsx") && !name.endsWith(".xls")) {
      toast.error("Format file harus .xlsx atau .xls");
      return;
    }
    try {
      setImporting(true);
      const { rows: parsed, skipped } = await parsePayrollHOFile(file);
      if (!parsed.length) {
        toast.error(
          "Tidak ada baris valid pada file." +
            (skipped.length ? " " + skipped[0] : "")
        );
        return;
      }
      const existing = await fetchAllPayroll();
      const existingSet = new Set(existing.map((r) => String(r.Nik).trim()));

      let inserted = 0;
      let updated = 0;
      let failed = 0;
      const failedNik = [];

      for (const p of parsed) {
        const isUpdate = existingSet.has(p.Nik);
        const fd = new FormData();
        Object.entries(p).forEach(([k, v]) => fd.append(k, v));
        const url = isUpdate ? "updateMasterPayrollHO" : "insertMasterPayrollHO";
        try {
          const res = await axios.post(API + url, fd, { headers: authHeader() });
          if (res.status === 200) {
            isUpdate ? updated++ : inserted++;
            existingSet.add(p.Nik);
          } else {
            failed++;
            failedNik.push(p.Nik);
          }
        } catch (err) {
          failed++;
          failedNik.push(p.Nik);
        }
      }

      toast.success(
        `Import selesai: ${inserted} ditambah, ${updated} diperbarui` +
          (failed ? `, ${failed} gagal` : "")
      );
      if (skipped.length)
        toast.warn(`${skipped.length} baris dilewati (Nik kosong)`);
      if (failedNik.length)
        toast.error(
          "Gagal untuk Nik: " +
            failedNik.slice(0, 8).join(", ") +
            (failedNik.length > 8 ? ", ..." : "")
        );
      loadAll();
    } catch (err) {
      toast.error("Gagal membaca file: " + (err.message || "unknown error"));
    } finally {
      setImporting(false);
    }
  }

  const btn =
    "flex items-center gap-2 justify-center h-10 px-4 rounded shadow text-sm font-semibold border transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                {/* ── Header + Filter ── */}
                <div className="w-full px-4 py-3 border-b">
                  <h3
                    className="text-lg font-bold"
                    style={{ color: Colors.primary }}
                  >
                    Master Payroll HO
                  </h3>
                  <p className="text-sm text-gray-500">
                    Kelola komponen gaji karyawan Head Office. Gunakan
                    Import/Export Excel untuk pengisian massal.
                  </p>
                  <div className="mt-3 w-full sm:w-1/3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Filter Tipe Karyawan
                    </label>
                    <Select
                      placeholder="Semua Tipe"
                      value={
                        tipeFilter
                          ? { value: tipeFilter, label: tipeFilter }
                          : null
                      }
                      onChange={(selected) =>
                        setTipeFilter(selected ? selected.value : "")
                      }
                      options={(tipeKaryawan?.minData || []).map((item) => ({
                        value: item.NamaTipeKaryawan,
                        label: item.NamaTipeKaryawan,
                      }))}
                      isClearable
                    />
                  </div>
                </div>

                {!firstLoading || mpayrol.isGetFetching ? (
                  <div className="w-full pt-0">
                    <Skeltons />
                  </div>
                ) : (
                  <>
                    {/* ── Toolbar: aksi kiri + search kanan ── */}
                    <div className="flex w-full justify-between px-4 pt-3 flex-col lg:flex-row gap-2">
                      <div className="flex flex-row gap-2 flex-wrap">
                        <button
                          onClick={openAdd}
                          className={
                            btn +
                            " bg-white text-gray-800 border-main-100 hover:bg-main-100 hover:text-white"
                          }
                        >
                          <BsPlusLg /> Tambah
                        </button>
                        <button
                          onClick={() => navigate("/master")}
                          className={
                            btn +
                            " bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                          }
                        >
                          <BsArrowLeft /> Kembali
                        </button>
                        <button
                          onClick={downloadPayrollHOTemplate}
                          className={
                            btn +
                            " bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                          }
                        >
                          <BsDownload /> Template
                        </button>
                        <label
                          className={
                            btn +
                            " bg-white text-gray-700 border-gray-300 " +
                            (importing
                              ? "opacity-50 cursor-not-allowed"
                              : "hover:bg-gray-100 cursor-pointer")
                          }
                        >
                          <BsUpload />
                          {importing ? "Mengimport..." : "Import Excel"}
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept=".xlsx,.xls"
                            hidden
                            disabled={importing}
                            onChange={handleImportFile}
                          />
                        </label>
                        <button
                          onClick={handleExportExcel}
                          disabled={exporting}
                          className={
                            btn +
                            " bg-white text-gray-800 border-green-600 hover:bg-green-600 hover:text-white"
                          }
                        >
                          <BsFileEarmarkExcelFill />
                          {exporting ? "Mengexport..." : "Export Excel"}
                        </button>
                        <button
                          onClick={handleExportPDF}
                          className={
                            btn +
                            " bg-white text-gray-800 border-red-400 hover:bg-red-400 hover:text-white"
                          }
                        >
                          <BsFilePdfFill /> Export PDF
                        </button>
                      </div>
                      <div className="flex flex-row w-full lg:w-96">
                        <input
                          type="text"
                          placeholder="Cari Nik / Nama / Bagian / Jabatan"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full h-10"
                        />
                      </div>
                    </div>

                    {/* ── Tabel ── */}
                    <div className="overflow-x-auto px-4 pt-2">
                      <table className="table-auto w-full text-sm text-left text-gray-500 mt-4">
                        <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                          <tr>
                            {[
                              "ID",
                              "Nik",
                              "Nama Karyawan",
                              "Bagian",
                              "Jabatan",
                              "Tipe",
                              "Upah Pokok",
                              "Keahlian",
                              "Jam IN",
                              "Jam OUT",
                              "Actions",
                            ].map((h, i) => (
                              <th key={i} scope="col" className="py-3 px-4 whitespace-nowrap">
                                {h}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pageRows.length === 0 ? (
                            <tr>
                              <td
                                colSpan={11}
                                className="text-center py-8 text-gray-400"
                              >
                                {searchQuery || tipeFilter
                                  ? "Tidak ada data yang cocok dengan filter"
                                  : "Tidak ada data payroll HO"}
                              </td>
                            </tr>
                          ) : (
                            pageRows.map((row, id) => (
                              <tr
                                key={row.ID || id}
                                className={
                                  id % 2 === 0
                                    ? "bg-gray-50 border-b"
                                    : "bg-white border-b"
                                }
                              >
                                <td className="py-3 px-4 whitespace-nowrap font-mono text-xs">
                                  {row.ID}
                                </td>
                                <td className="py-3 px-4 whitespace-nowrap font-mono text-xs">
                                  {row.Nik}
                                </td>
                                <td className="py-3 px-4">{row.NamaKaryawan || "-"}</td>
                                <td className="py-3 px-4">{row.NamaBagian || "-"}</td>
                                <td className="py-3 px-4">{row.NamaJabatan || "-"}</td>
                                <td className="py-3 px-4 whitespace-nowrap">
                                  {row.TipeKaryawan || "-"}
                                </td>
                                <td className="py-3 px-4 whitespace-nowrap text-right">
                                  {rp(row.UpahPokok)}
                                </td>
                                <td className="py-3 px-4 whitespace-nowrap text-right">
                                  {rp(row.Keahlian)}
                                </td>
                                <td className="py-3 px-4 whitespace-nowrap">{row.JkIN || "-"}</td>
                                <td className="py-3 px-4 whitespace-nowrap">{row.JkOUT || "-"}</td>
                                <td className="py-3 px-4 whitespace-nowrap">
                                  <button
                                    onClick={() => openEdit(row)}
                                    className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-3 border border-gray-400 rounded shadow text-sm"
                                  >
                                    Edit
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* ── Info + Pagination ── */}
                    <div className="flex flex-row justify-between items-center gap-4 px-4 py-4 text-sm text-gray-600">
                      <span>{filtered.length} data</span>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => setPageC((p) => Math.max(1, p - 1))}
                          disabled={safePage <= 1}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Prev
                        </button>
                        <span>
                          Page {safePage} / {totalPage}
                        </span>
                        <button
                          onClick={() =>
                            setPageC((p) => Math.min(totalPage, p + 1))
                          }
                          disabled={safePage >= totalPage}
                          className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>

      {showModalAdd && (
        <ModalForm
          showModal={showModalAdd}
          addEnabled={true}
          modal={handleModal}
          modalTitle="Tambah Master Payroll HO"
          dropdownKaryawan={true}
          inputOneTitle="Upah Pokok"
          inputOneType="number"
          inputTwoTitle="Keahlian"
          inputTwoType="number"
          inputThreeTitle="Jam Kerja IN (08:00)"
          inputThreeType="text"
          inputFourTitle="Jam Kerja OUT (17:00)"
          inputFourType="text"
          inputFiveTitle="Tunjangan Harian"
          inputFiveType="number"
          inputSixTitle="Tunjangan Makan"
          inputSixType="number"
          dropDownDay={true}
          submitButtonTitle="Submit"
          handleSubmit={handleInsertPayroll}
        />
      )}
      {showModalEdit && (
        <ModalForm
          showModal={showModalEdit}
          id={currentData.ID}
          modal={handleModal}
          modalTitle="Ubah Master Payroll HO"
          dropdownKaryawan={true}
          dropdownKaryawanValue={currentData.Nik}
          inputOneTitle="Upah Pokok"
          inputOneValue={currentData.UpahPokok}
          inputTwoTitle="Keahlian"
          inputTwoValue={currentData.Keahlian}
          inputThreeTitle="Jam Kerja IN (08:00)"
          inputThreeValue={currentData.JkIN}
          inputFourTitle="Jam Kerja OUT (17:00)"
          inputFourValue={currentData.JkOUT}
          inputFiveTitle="Tunjangan Harian"
          inputFiveValue={currentData.THarian}
          inputSixTitle="Tunjangan Makan"
          inputSixValue={currentData.TLemburMakan}
          dropDownDay={true}
          dropDownDayValue={currentData.Harikeenam}
          submitButtonTitle="Submit"
          handleSubmit={handleUpdatePayroll}
        />
      )}
    </>
  );
};

export default MPayrollPageHO;
